import { Navigate } from 'react-router-dom';
import { ReactSession } from '../utils/ReactSession.jsx';
import {AES, enc} from "crypto-js";
import { useParams } from "react-router";
import LegacyEventReports from "./LegacyEventReports.jsx";
import EventReports from "./EventReports.jsx";
import ScheduledReports from "./ScheduledReports.jsx";
import WellnessReports from "./WellnessReports.jsx";
import SessionReload from "./component-assets/SessionReload.jsx";
import HourlyReports from "./HourlyReports.jsx";
import ExecutiveReport from "./ExecutiveReport.jsx";
import EnvironmentReports from "./EnvironmentReports.jsx";
import MaintenanceReports from "./MaintenanceReports.jsx";
import {compareRole, iAmHigherAuthority} from "../libs.jsx";
import MaintenanceCloudReports from "./MaintenanceCloudReports.jsx";
import { usePortalVersion } from '../contexts/PortalVersionContext.jsx';
import AlertDetailsPage from '../pages/reports/alert-details/AlertDetailsPage.jsx';
import HourlySummaryPage from '../pages/reports/hourly-summary/HourlySummaryPage.jsx';
import MaintenanceReportPage from '../pages/reports/maintenance/MaintenanceReportPage.jsx';
import WellnessReportsPage from '../pages/reports/wellness/WellnessReportsPage.jsx';
import EnvironmentalReportsPage from '../pages/reports/environmental/EnvironmentalReportsPage.jsx';
import ScheduledReportsPage from '../pages/reports/scheduled/ScheduledReportsPage.jsx';
import ExecutiveReportPage from '../pages/reports/executive/ExecutiveReportPage.jsx';

const Reports = (props) => {
    const { portalVersion } = usePortalVersion();
    const isV2 = portalVersion === 'v2';
    let reportContent, dData, paramVars, bData;
    paramVars = useParams();

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), import.meta.env.VITE_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    if (dData?.migrated){
        if (paramVars.dType === "alerts"){
            reportContent = isV2
                ? <AlertDetailsPage run={paramVars?.eType === "run"} />
                : <EventReports toFetch={"alerts"} run={paramVars?.eType === "run"} />;
        }else if (paramVars.dType === "maintenance"){
            if (isV2) {
                reportContent = <MaintenanceReportPage />;
            } else if (dData?.campusData[dData?.acnt.toString()]?.is_cloud){
                reportContent = <MaintenanceCloudReports />
            }else{
                reportContent = <MaintenanceReports />;
            }
        }else if (paramVars.dType === "wellness"){
            reportContent = isV2 ? <WellnessReportsPage /> : <WellnessReports />;
        }else if (paramVars.dType === "scheduled"){
            reportContent = isV2 ? <ScheduledReportsPage /> : <ScheduledReports />;
        }else if (paramVars.dType === "grouped"){
            reportContent = isV2 ? <HourlySummaryPage /> : <HourlyReports />;
        }else if (paramVars.dType === "hourly"){
            reportContent = isV2 ? <HourlySummaryPage /> : <HourlyReports />;
        }else if (paramVars.dType === "executive"){
            reportContent = isV2 ? <ExecutiveReportPage /> : <ExecutiveReport />;
        }else if (paramVars.dType === "environmental"){
            reportContent = isV2 ? <EnvironmentalReportsPage /> : <EnvironmentReports />;
        }else{
            reportContent = (
                <div>
                    <h3>Page not found. 404</h3>
                </div>
            );
        }
    }else{
        if (paramVars.dType === "alerts"){
            reportContent = <LegacyEventReports toFetch={"alerts"}/>;
        }
        else if (paramVars.dType === "resident"){
            reportContent = <LegacyEventReports toFetch={"resident"}/>;
        }
        else if (paramVars.dType === "caregiver"){
            reportContent = <LegacyEventReports toFetch={"caregiver"}/>;
        }
        else if (paramVars.dType === "maintenance"){
            reportContent = <LegacyEventReports toFetch={"maintenance"}/>;
        }
        else if (paramVars.dType === "inspection"){
            reportContent = <LegacyEventReports toFetch={"inspection"}/>;
        }
        else if (paramVars.dType === "checkin-transaction"){
            reportContent = <LegacyEventReports toFetch={"checkin-transaction"}/>;
        }
        else if (paramVars.dType === "checkin-history"){
            reportContent = <LegacyEventReports toFetch={"checkin-history"}/>;
        }
        else{
            reportContent = (
                <div>
                    <h3>Page not found. 404</h3>
                </div>
            );
        }
    }

    return (compareRole("caregiver", dData?.userrole) || iAmHigherAuthority(10, dData?.role_weight)) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {reportContent}
        </>
    ) : <Navigate to={"/"}/>;
};

export default Reports;